export * from './ng-4-geoautocomplete.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Works/Respite/respite_app/UI/~/ng4-geoautocomplete/index.js
// module id = ../../../../ng4-geoautocomplete/index.js
// module chunks = 4